module.exports = __webpack_public_path__ + "static/media/project17.01125ec5.png";